import { render, staticRenderFns } from "./profile-ip.vue?vue&type=template&id=daa481ec&scoped=true"
import script from "./profile-ip.vue?vue&type=script&lang=js"
export * from "./profile-ip.vue?vue&type=script&lang=js"
import style0 from "./profile-ip.vue?vue&type=style&index=0&id=daa481ec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa481ec",
  null
  
)

export default component.exports